<template>
	<LoginLayout
		v-if="showErrorScreen"
		heading="Link expired"
		secondary-text="Your link is invalid or has expired"
	>
		<template #form>
			<div class="text-center">
				<div class="login-icon-roundel mb-6">
					<v-icon size="32">
						mdi-link-variant-off
					</v-icon>
				</div>
				<p>
					<a @click="$router.push({ path: '/login' })">
						Please click here to login.
					</a>
				</p>
			</div>
		</template>
	</LoginLayout>
</template>
<script>
import { mapActions } from 'vuex'
import LoginLayout from '../../../../../shared/layouts/login-layout.vue'
export default {
	components: { LoginLayout },
	props: {
		otp: String
	},
	data () {
		return {
			showErrorScreen: false
		}
	},
	created () {
		this.tryOtpLogin()
	},
	methods: {
		...mapActions('auth', ['otpLogIn']),
		// Vue is daft and converts '+' to ' ' in the URL, so we need to convert it back to '+' before sending it to the API
		cleanOtp () {
			return this.otp.replace(/ /g, '+')
		},
		tryOtpLogin () {
			const mfaGuid = localStorage.getItem('mfaGuid')
			return this.otpLogIn({
				otpCode: this.cleanOtp(),
				mfaGuid
			})
				.then(user => {
					if (user.userId != null) {
						this.$router.push({ name: 'dashboard' })
					}	else {
						this.showErrorScreen = true
					}
				})
				.catch(error => {
					if (error?.response?.status === 401) {
						this.$router.push({ name: 'account-locked-out' })
					}	else {
						this.showErrorScreen = true
					}
				})
		}
	}
}
</script>
